/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/return-await */
import { type TotalContribution } from 'pages/Contributions';
import ApiUtil from '../utils/ApiUtil';
import { contributionApiUrls, contributionUrls } from 'constants/apiEndPoints';
import { strings } from 'i18n/Strings';
import QueryParamsBuilder from 'components/helpers/commonFunctions/QueryParamsBuilder';
import { type HoldingsFilters } from 'pages/employeesDetails/holdings/currentHoldings';
import { commonConstantTexts } from 'constants/constantText';

const getTotalContributionOfOrganization = async (organizationId: number): Promise<TotalContribution> => {
    return ApiUtil.postWithToken(`${contributionApiUrls.getTotalContributionOfOrganizationUrl}/${organizationId}`) as Promise<TotalContribution>;
}

const getOrganizationContribution = async (organizationId: string, page: number, size: number, sortBy: string,
    sortOrder: string, searchValue: string): Promise<unknown> => {
    const url = QueryParamsBuilder({ baseUrl: `${contributionApiUrls.getOrganizationContribution}/${organizationId}`, page, size, sortBy, sortOrder, searchValue });
    return ApiUtil.getWithToken(url);
}

const getEmployeeContribution = async (userId: string): Promise<unknown> => {
    return ApiUtil.getWithToken(`${contributionApiUrls.getEmployeeContribution}/${userId}`);
}

const uploadContributionFile = async (organizationId: number, contributionData: { file: File; startDate: string; empId: string, isPreview: boolean, finalizedData: [] }): Promise<unknown> =>
    await
        new Promise((resolve, reject) => {
            const { file, startDate, empId, isPreview, finalizedData } = contributionData
            const formData = new FormData();
            formData.append('startDate', startDate);
            // formData.append('endDate', endDate);
            formData.append('file', file);
            formData.append('empId', empId);
            formData.append('isPreview', isPreview.toString());
            formData.append('finalizedData', JSON.stringify(finalizedData || []))
            ApiUtil.postWithToken(`${String(contributionUrls.contributionUpload)}${organizationId}`, formData)
                .then((res) => {
                    resolve(res)
                }).catch((error) => { reject(error); })
        })




const removeContributionEmployeeEntry = async (id: number, data: object): Promise<unknown> => {
    try {
        return await ApiUtil.postWithToken(`${contributionApiUrls.removeContributionEmployeeEntryUrl}/${id}`, { data });

    } catch (error) {
        throw new Error(`${strings.displayText.unableToDeleteEmployeeText}. ${String(error)}`);
    }
};
/*    Reupload function not using currently
const uploadAgainEmployeeContribution = async (id: number, data: object): Promise<unknown> => {
    try {
        return await ApiUtil.postWithToken(`${contributionApiUrls.uploadAgainEmployeeContributionUrl}/${id}`, data);

    } catch (error) {
        throw new Error(`${strings.displayText.unableToDeleteEmployeeText}. ${String(error)}`);
    }
};
*/
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getAllOrganizationContributionFiles = async (page: number, size: number, sortBy: string, sortOrder: string, searchValue: string, filters: any, deleted?: boolean): Promise<unknown> => {

    let url = QueryParamsBuilder({ baseUrl: contributionApiUrls.getOrganizationContributionFilesUrl, page, size, sortBy, sortOrder, searchValue });
    url = generateContributionUrl(filters, url);
    return await ApiUtil.getWithToken(url)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const exportAllOrganizationContributionFiles = async (searchValue: string, filters: unknown): Promise<unknown> => {
    return new Promise((resolve, reject) => {
        let apiUrl = QueryParamsBuilder({ baseUrl: contributionApiUrls.exportOrganizationContributionFilesUrl, searchValue });
        apiUrl = generateContributionUrl(filters, apiUrl);
        ApiUtil.getExcelFile(apiUrl)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((res: any) => {
                const blob = new Blob([res.data], {
                    type: res.headers['content-type'],
                });
                const url = URL.createObjectURL(blob);
                resolve(url);
            })
            .catch((error) => {
                reject(error);
            });
    })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const exportMyOrganizationContributionFiles = async (orgId: number, searchValue: string, filters: unknown): Promise<unknown> => {
    return new Promise((resolve, reject) => {
        let apiUrl = QueryParamsBuilder({ baseUrl: `${contributionApiUrls.exportOrganizationContributionFilesUrl}/${orgId}`, searchValue });
        apiUrl = generateContributionUrl(filters, apiUrl);
        ApiUtil.getExcelFile(apiUrl)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((res: any) => {
                const blob = new Blob([res.data], {
                    type: res.headers['content-type'],
                });
                const url = URL.createObjectURL(blob);
                resolve(url);
            })
            .catch((error) => {
                reject(error);
            });
    })
}

const getOrganizationContributionFiles = async (id: number, page: number, size: number, searchValue: string, deleted?: boolean): Promise<unknown> => {
    return await ApiUtil.getWithToken(`${contributionApiUrls.getOrganizationContributionFilesUrl}/${id}?page=${page}&size=${size}&searchValue=${searchValue}&deleted=${deleted}`)
}
const getContributionHoldingById = async (id: number, page: number, size: number): Promise<unknown> => {
    return await ApiUtil.getWithToken(`${contributionApiUrls.getContributionHoldings}/${id}?page=${page}&size=${size}`)
}

const getContributionFrequency = async (organizationId: number): Promise<unknown> => {
    return await ApiUtil.getWithToken(`${contributionApiUrls.getTotalContributionOfOrganizationUrl}/${organizationId}`) as Promise<TotalContribution>;
}

const getContributionFile = async (key: string): Promise<unknown> => {
    return await ApiUtil.postWithToken(contributionApiUrls.getContributionFileUrl, { key })
}
const deleteContributionFile = async (data: {
    contributionFileId: number,
    key: string,
}): Promise<unknown> => {
    return await ApiUtil.postWithToken(contributionApiUrls.deleteContributionFileUrl, { data })
}

const getContributionFileDetails = async (contributionFileId: string): Promise<unknown> => {
    return ApiUtil.getWithToken(`${contributionApiUrls.getContributionFileDetailsUrl}/${contributionFileId}`)
}

const getMonthWiseContributionHoldingById = async (id: number, page: number, size: number, filters: HoldingsFilters): Promise<unknown> => {
    try {
        let url = QueryParamsBuilder({ baseUrl: `${contributionApiUrls.getMonthWiseContributionHoldings}/${id}`, page, size });
        const filterParams = new URLSearchParams();
        if (filters) {
            if (filters.startDate) {
                filterParams.append('startDate', filters.startDate);
            }
            if (filters.endDate) {
                filterParams.append('endDate', filters.endDate)
            }
        }

        if (filterParams.toString()) {
            url += `&${filterParams.toString()}`;
        }

        const response = await ApiUtil.getWithToken(url);
        return response
    } catch (error) {
        console.error(error);
        throw error;
    }
}

const getUserContribution = async (userId: string, page: number, size: number, sortBy: string,
    sortOrder: string): Promise<unknown> => {
    const url = QueryParamsBuilder({ baseUrl: `${contributionApiUrls.getUserContribution}/${userId}`, page, size, sortBy, sortOrder });
    return ApiUtil.getWithToken(url);
}

export {
    exportMyOrganizationContributionFiles,
    exportAllOrganizationContributionFiles,
    getAllOrganizationContributionFiles,
    getTotalContributionOfOrganization,
    uploadContributionFile,
    removeContributionEmployeeEntry,
    getOrganizationContributionFiles,
    getContributionFile, deleteContributionFile,
    getContributionHoldingById,
    getOrganizationContribution,
    getEmployeeContribution,
    getContributionFileDetails,
    getMonthWiseContributionHoldingById,
    getContributionFrequency,
    getUserContribution
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function generateContributionUrl(filters: unknown, url: string) {
    const filterParams = new URLSearchParams();
    if (filters) {
        if (filters.startDate) {
            filterParams.append('startDate', filters.startDate);
        }

        if (filters.endDate) {
            filterParams.append('endDate', filters.endDate);
        }

        if (filters.frequencyType) {
            const frequencyType = filters.frequencyType || '';
            filterParams.append('frequencyType', frequencyType);
        }

        if (filters.status) {
            const status = filters.status;

            if (status === commonConstantTexts.deleted) {
                filterParams.append('deleted', 'true');
            } else {
                filterParams.append('status', status);
                filterParams.append('deleted', 'false');
            }
        }
        if (filters.deleted !== undefined) {
            filterParams.append("deleted", filters.deleted);
        }
        if (filters.orgId) {
            const orgId = filters.orgId || '';
            filterParams.append("orgId", orgId);
        }
    }

    if (filterParams.toString()) {
        url += `&${filterParams.toString()}`;
    }
    return url;
}

